var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import styles from "@bookingcom/bui-core/css/Scrim.module.css";
var Scrim = function (props) {
    var children = props.children, backgroundSlot = props.backgroundSlot, fill = props.fill, _a = props.position, position = _a === void 0 ? "full" : _a, centered = props.centered, attributes = props.attributes, className = props.className, borderRadius = props.borderRadius;
    var rootClassName = classNames(styles.root, !!backgroundSlot && styles["root--with-background"], fill && styles["root--fill"], centered && styles["root--centered"], position && styles["root--position-".concat(position)], borderRadius && styles["root--border-radius-".concat(borderRadius)], className);
    return (React.createElement("div", __assign({}, attributes, { className: rootClassName }),
        backgroundSlot,
        React.createElement("div", { className: styles.scrim },
            React.createElement("div", { className: styles.content }, children))));
};
export default Scrim;
